import React from 'react';
import { Button } from './Button';
export function Hero() {
  return <section className="w-full bg-[#0F0F0F] text-[#F5F5F5] py-28 md:py-40 lg:py-48 relative overflow-hidden" data-id="element-188">
      {/* Background Image with Gradient Mask */}
      <div className="absolute inset-0" data-id="element-189">
        <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1920&q=80" alt="" className="w-full h-full object-cover" data-id="element-190" />
        {/* Gradient overlay: bottom 100%, middle (85%) 80%, top 20% */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F0F0F] via-[#0F0F0F]/80 via-85% to-[#0F0F0F]/20" data-id="element-191"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-192">
        <h1 className="font-['Poppins'] font-bold text-4xl md:text-6xl lg:text-7xl leading-[1.15] mb-8 tracking-tight text-[#F5F5F5]" data-id="element-193">
          Your 24/7 AI Answering Service That Grows Your Business
        </h1>
        <p className="font-['Inter'] text-lg md:text-xl lg:text-2xl text-[#A0A0A0] max-w-4xl mx-auto mb-12 leading-relaxed font-light" data-id="element-194">
          Instant call pickup, professional message capture, and a fully branded
          AI agent designed to improve customer satisfaction and support your
          business around the clock.
        </p>
        <Button size="lg" data-id="element-195">Start Free 7-Day Trial</Button>
      </div>
    </section>;
}